export default __webpack_public_path__ + "static/mantas-39e74e998a07353fd4a861a99ee49cb3.png";